import React from 'react';
import { scaffoldingRows } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Scaffolding() {
  return <section className="relative w-full overflow-hidden bg-night px-5 py-20 sm:py-28" data-id="element-188" data-mp="2k48cor9erqal">
      <div className="bg-stripes absolute inset-0" aria-hidden="true" data-id="element-189" data-mp="2k1vtybvttbwh" />
      <div className="relative mx-auto max-w-6xl" data-id="element-190" data-mp="2g3elnp0o5vdh">
        <SectionHeading eyebrow="Andamiaje lingüístico" tone="dark" title={<>
              La estrategia de{' '}
              <span className="text-volt" data-id="element-192" data-mp="1nbuyxv4v5z6q">Scaffolding</span>
            </>} subtitle="Para que ningún alumno se bloquee y tú no tengas que traducir cada instrucción: el kit define cuánto inglés y cuánto español usar en cada etapa." data-id="element-191" data-mp="1sciwz0rifgag" />

        <Reveal delay={0.06} data-id="element-193" data-mp="18o052bf4dos2">
          <div className="no-scrollbar mt-14 overflow-x-auto rounded-3xl border-2 border-ink bg-white" data-id="element-194" data-mp="18n8g3jg12par">
            <table className="w-full min-w-[760px] border-collapse text-left" data-id="element-195" data-mp="14ldhwnte8s17">
              <caption className="sr-only" data-id="element-196" data-mp="1qdbupmgn01i0">
                Proporción sugerida de inglés y español por etapa de
                aprendizaje
              </caption>
              <thead data-id="element-197" data-mp="203emjjc0v9er">
                <tr className="bg-ink" data-id="element-198" data-mp="204zhha290ud5">
                  <th scope="col" className="px-6 py-4 font-display text-xs tracking-[0.14em] text-volt" data-id="element-199" data-mp="2060x7ru7m517">
                    Etapa
                  </th>
                  <th scope="col" className="px-6 py-4 font-display text-xs tracking-[0.14em] text-white/70" data-id="element-200" data-mp="1cdu2sy81o84f">
                    Equivalencia sugerida
                  </th>
                  <th scope="col" className="px-6 py-4 font-display text-xs tracking-[0.14em] text-white/70" data-id="element-201" data-mp="1mdbafl6uww31">
                    Inglés / Español en el aula
                  </th>
                  <th scope="col" className="px-6 py-4 font-display text-xs tracking-[0.14em] text-white/70" data-id="element-202" data-mp="2xtja9euwltb0">
                    Enfoque pedagógico
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-203" data-mp="16pbzc18569cp">
                {scaffoldingRows.map((row, index) => <tr key={row.stage} className={index > 0 ? 'border-t-2 border-ink/10' : ''} data-id="element-204" data-mp="12pbkwgl1ly5n" data-mpi={index}>
                    <th scope="row" className="whitespace-nowrap px-6 py-6 align-top font-display text-lg text-ink" data-id="element-205" data-mp="ewbn8vz4ntvh">
                      {row.stage}
                    </th>
                    <td className="px-6 py-6 align-top text-sm font-semibold leading-snug text-ink/60" data-id="element-206" data-mp="iz886tc5422l">
                      {row.equivalence}
                    </td>
                    <td className="px-6 py-6 align-top" data-id="element-207" data-mp="3ner70y9bgyoy">
                      <div className="flex h-3 w-full min-w-[9rem] overflow-hidden rounded-full border border-ink/15" aria-hidden="true" data-id="element-208" data-mp="3ne927d8l9c5f">
                        <span className="block bg-brand" style={{
                      width: `${row.englishPct}%`
                    }} data-id="element-209" data-mp="3i3domo3qjb6m" />
                        <span className="block bg-volt" style={{
                      width: `${100 - row.englishPct}%`
                    }} data-id="element-210" data-mp="38c9bltxme0ef" />
                      </div>
                      <p className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm font-bold" data-id="element-211" data-mp="4u8zc2l178v0">
                        <span className="text-brand" data-id="element-212" data-mp="3m2miru2otb2p">
                          Inglés {row.english}
                        </span>
                        <span className="text-ink/45" data-id="element-213" data-mp="2anpgvjlemrdx">
                          Español {row.spanish}
                        </span>
                      </p>
                    </td>
                    <td className="px-6 py-6 align-top text-base leading-snug text-ink/80" data-id="element-214" data-mp="2fkpo3xtzq06m">
                      {row.focus}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Reveal>

        <p className="mt-5 text-center text-xs font-semibold uppercase tracking-[0.14em] text-white/40 sm:hidden" data-id="element-215" data-mp="2m4x2si2aj4fv">
          Desliza para ver la tabla completa →
        </p>
      </div>
    </section>;
}